import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = hash.split('session_id=')[1]?.split('&')[0];

    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    const processWithRetry = async (id, retries = 3) => {
      for (let i = 0; i < retries; i++) {
        try {
          return await processGoogleSession(id);
        } catch (err) {
          console.error(`Auth attempt ${i + 1} failed:`, err);
          if (i < retries - 1) await new Promise(r => setTimeout(r, 1000 * (i + 1)));
          else throw err;
        }
      }
    };

    (async () => {
      try {
        const userData = await processWithRetry(sessionId);
        window.history.replaceState(null, '', window.location.pathname);
        const returnUrl = sessionStorage.getItem('auth_return_url');
        sessionStorage.removeItem('auth_return_url');
        if (!userData.profile_completed) {
          navigate('/complete-profile', { replace: true, state: { user: userData } });
        } else {
          navigate(returnUrl || '/', { replace: true, state: { user: userData } });
        }
      } catch (err) {
        console.error('Auth callback error after retries:', err);
        navigate('/', { replace: true });
      }
    })();
  }, [navigate, processGoogleSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream-50">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-blush-200 border-t-blush-400 rounded-full animate-spin mx-auto mb-4" />
        <p className="font-body text-[#78716C]">Signing you in...</p>
      </div>
    </div>
  );
}
